import { createAsyncThunk, current } from '@reduxjs/toolkit';
import { axiosInstance } from '../../../utils/axiosInterceptor';

export const initStateGetCandidateList = {
  getCandidateList: { data: null, loading: false, error: null },
};

export const getCandidateList = createAsyncThunk('user/getCandidateList', async (id, { rejectWithValue, fulfillWithValue }) => {
  return await axiosInstance
    .get(`${process.env.REACT_APP_SERVER_API}/vacancies/${id}/broadcast/candidates`, {
      headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` },
    })
    .then((res) => {
      return fulfillWithValue(res.data);
    })
    .catch((res) => {
      return rejectWithValue(res.response.data);
    });
});

export const reducerGetCandidateList = {
  [getCandidateList.pending]: (state) => {
    state.getCandidateList.loading = true;
    state.getCandidateList.error = null;
  },
  [getCandidateList.fulfilled]: (state, action) => {
    state.getCandidateList.loading = false;
    state.getCandidateList.data = action.payload;
    state.getCandidateList.error = null;
  },
  [getCandidateList.rejected]: (state, action) => {
    state.getCandidateList.loading = false;
    state.getCandidateList.error = true;
  },
};
